"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.default = {
    root: {
        display: 'block',
        width: '100%',
        height: 'auto',
        '&[data-nth="1"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_1
        },
        '&[data-nth="2"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_2
        },
        '&[data-nth="3"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_3
        },
        '&[data-nth="4"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_4
        },
        '&[data-nth="5"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_5
        },
        '&[data-nth="6"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_6
        },
        '&[data-nth="7"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_7
        },
        '&[data-nth="8"]': {
            fill: constants_1.AVATAR_GROUP_COLOR_8
        }
    }
};
//# sourceMappingURL=avatar.group.colour.style.js.map